import type { StatusTone } from "@/components/status-badge"
import type {
  IntakeLoad,
  LoadDecision,
  LoadGrade,
  LoadStatus,
} from "@/features/intake/api/types"

export type IntakeStage = "PENDING" | LoadStatus

export const STAGES: IntakeStage[] = [
  "PENDING",
  "SCALE",
  "QUALITY",
  "COMPLETED",
]

export function stageStepIndex(status: LoadStatus): number {
  switch (status) {
    case "SCALE":
      return 0
    case "QUALITY":
      return 1
    case "COMPLETED":
      return 2
  }
}

export function stageTone(stage: IntakeStage): StatusTone {
  switch (stage) {
    case "PENDING":
      return "warning"
    case "SCALE":
      return "info"
    case "QUALITY":
      return "info"
    case "COMPLETED":
      return "success"
  }
}

export function decisionTone(decision: LoadDecision | null | undefined): StatusTone {
  if (!decision) return "muted"
  return decision === "ACCEPTED" ? "success" : "danger"
}

export function gradeTone(grade: LoadGrade | null | undefined): StatusTone {
  switch (grade) {
    case "GRADE_1":
      return "success"
    case "GRADE_2":
      return "info"
    case "SOUS_GRADE":
      return "warning"
    case "REFUSED":
      return "danger"
    default:
      return "muted"
  }
}

export function loadStageBucket(load: IntakeLoad): IntakeStage {
  return load.status
}
